import { FormatSegment } from '@app/app/_components/DatePicker/FormatSegment';

export function buildInputValue(rawDigits: string, segments: FormatSegment[]): string {
    let result = '';
    let digitIndex = 0;

    for (const seg of segments) {
        if (seg.kind === 'separator') {
            if (rawDigits.length > digitIndex) {
                result += seg.char;
            }
        } else {
            const segmentEnd = Math.min(digitIndex + seg.length, rawDigits.length);
            const availableDigits = rawDigits.slice(digitIndex, segmentEnd);
            result += availableDigits;
            digitIndex += seg.length;
        }
    }

    return result;
}
